import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import {getAuditReports, getAuditReportRuns} from '../reporting-audit.actions';

class ReportingAuditGridComponent extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.module = 'reporting';
        this.identifier = 'reportingAuditGrid';
        this.exportComponent = false;
        this.filterTemplate = './reporting-audit-grid-filter.html';

        this.columns = [
            {title: '#',                            mapper: null},
            {title: 'Head Office',                  mapper: 'headOffice'},
            {title: 'Site Location',                mapper: 'siteLocation'},
            {title: 'Type',                         mapper: 'runType'},
            {title: 'Created At',                   mapper: 'createdAt'},
            {title: 'Start Date',                   mapper: 'startDate'},
            {title: 'End Date',                     mapper: 'endDate'},
            {title: 'Error Message',                mapper: 'errorMessage'},
            {title: 'Document',                     mapper: 'fileName'},
            {title: 'Status',                       mapper: 'status'},
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getAuditReports, getAuditReportRuns }
        )(this);

        this.dataAction = this.getAuditReports;
        this.filter.identifier = this.identifier;
        this.getAuditReportRuns();

        this.buttons =[ {
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event)
            },
            filter: item => {
                return item.uri
            },
        }];

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

export const reportingAuditGrid = {
    bindings: {
        onReset: '&',
        onDownload: '&'
    },
    controller: ReportingAuditGridComponent,
    ...gridTpl
};
